var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangleSemicircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_21",
    "data-name": "Grupo 21",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.19,
    height: 43.19,
    viewBox: "0 0 43.19 43.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M0,34.241a21.6,21.6,0,1,1,21.6,21.6A21.6,21.6,0,0,1,0,34.241",
    transform: "translate(0 -12.646)",
    fill: "#c3dad4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2",
    "data-name": "Ret\\xE2ngulo 2",
    width: 43.19,
    height: 21.595,
    transform: "translate(0 0)",
    fill: "#ae88bd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleSemicircle);
export default __webpack_public_path__ + "static/media/rectangle-semicircle.79257574a23787e29f06f1d78e1a1cee.svg";
export { ForwardRef as ReactComponent };